(function (root) {
  'use strict';
  const compatible = (entry, variantId) => entry.scope === 'all' ||
    (entry.scope === 'variants' && entry.keyboardVariants.includes(String(variantId)));
  const signature = (item) => JSON.stringify([
    String(item.variant_id || item.id),
    String(item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || ''),
    Object.entries(item.properties || {}).filter(([, value]) => value !== '' && value != null)
      .sort(([a], [b]) => a.localeCompare(b)),
  ]);
  const quantityOf = (cart, item) => cart.items.reduce((sum, line) =>
    sum + (signature(line) === signature(item) ? line.quantity : 0), 0);
  const reconcile = (before, after, items) => items.map((item) => {
    const added = Math.max(0, quantityOf(after, item) - quantityOf(before, item));
    return { ...item, added, missing: Math.max(0, item.quantity - added) };
  });
  const selectVariant = (variants, selected, fallbackId, names) => {
    const options = Object.entries(selected || {});
    if (!options.length) return variants.find((variant) => String(variant.id) === String(fallbackId));
    return variants.find((variant) => options.length === variant.options.length && options.every(([key, value]) => {
      const index = names.indexOf(key);
      return index >= 0 && (variant[`option${index + 1}`] ?? variant.options[index]) === value;
    }));
  };
  class Purchase {
    constructor(fetcher, rootUrl) { this.fetcher = fetcher; this.rootUrl = rootUrl; this.busy = false; this.uncertain = false; }
    async request(path, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await this.fetcher(this.rootUrl + path, { ...options, signal: controller.signal, cache: 'no-store' });
        const data = await response.json();
        if (!response.ok || data.status >= 400 || data.errors) throw new Error(data.description || data.message || 'Cart request failed');
        return data;
      } finally { clearTimeout(timer); }
    }
    async add(items, sections, path) {
      if (this.busy || this.uncertain) return { blocked: true };
      this.busy = true;
      let before;
      let attempted = false;
      let data;
      let error;
      try {
        before = await this.request('cart.js');
        attempted = true;
        try {
          data = await this.request('cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: path }),
          });
        } catch (failure) { error = failure; }
        const after = await this.request('cart.js');
        const lines = reconcile(before, after, items);
        const complete = !error && lines.every((line) => line.missing === 0);
        this.uncertain = !complete;
        return { complete, lines, cart: after, sections: data?.sections, error };
      } catch (failure) {
        this.uncertain = attempted;
        return { complete: false, uncertain: attempted, error: failure };
      } finally { this.busy = false; }
    }
  }
  const api = { compatible, signature, reconcile, selectVariant, Purchase };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.KikAccessoryCore = api;
})(globalThis);
